import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import { Dispatch, FC, SetStateAction } from 'react'

export const AttestationReportActions: FC<{
  setDisplayAddForm: Dispatch<SetStateAction<boolean>>
}> = ({ setDisplayAddForm }) => (
  <Button
    color="primary"
    startIcon={<Add />}
    style={{ marginBottom: '16px' }}
    variant="contained"
    onClick={() => setDisplayAddForm(true)}
  >
    Nuevo
  </Button>
)
